import {Component, Injector} from '@angular/core';
import {ApiResponse} from '../../../../../Services/Api/base-api.service';
import {WidgetDataControllerComponent} from '../../../../Controller/widget-data-controller-component';
import {DocumentsReviewApiService} from '../../../../../Services/Api/Documents-review/documents-review-api.service';
import {UnclassifiedDocumentReviewDto} from '../../../../../Models/Documents-review/unclassified-document-review.interface';
import {DocumentsReviewFilters} from '../../../../../Models/Documents-review/documents-review-filters.model';

@Component({
  selector: 'app-unclassified-review-widget',
  templateUrl: './unclassified-review-widget.component.html',
  styleUrls: ['./unclassified-review-widget.component.scss'],
  standalone: false,
})
export class UnclassifiedReviewWidgetComponent extends WidgetDataControllerComponent<number> {

  override fakeData: number = 2;

  get widgetData(): number {
    return this.data || this.data === 0 ? this.data : this.fakeData;
  }

  constructor(
    protected override injector: Injector,
    protected documentsReviewService: DocumentsReviewApiService,
  ) {
    super(injector, documentsReviewService);
  }


  /**
   * Obtener el número de documentos sin clasificar
   *
   */
  override setData(data: UnclassifiedDocumentReviewDto[]) {
    this.data = data?.length || 0;
  }


  /**
   * Obtener datos
   *
   */
  getData(): Promise<ApiResponse> {
    const filters = new DocumentsReviewFilters();
    filters.store_id = this.widgetsManager.filters ? this.widgetsManager.filters.local?.id : 0;
    return this.documentsReviewService.getUnclassifiedDocuments(filters);
  }

}
